export const EVENT_CATEGORY_ADD_INIT = 'CATEGORY_ADD_INIT'

export const EVENT_CATEGORY_UPDATE_INIT = 'CATEGORY_UPDATE_INIT'

export const EVENT_CATEGORY_UPDATE_SUCCESS = 'CATEGORY_UPDATE_SUCCESS'

export const EVENT_CATEGORY_DETAIL_INIT = 'CATEGORY_DETAIL_INIT'

export const EVENT_CATEGORY_DELETE_INIT = 'CATEGORY_DELETE_INIT'

